import React, { useEffect } from 'react';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { Navigate, useParams, useLocation } from 'react-router-dom';
import { CenterFrameLayout } from 'Layouts';
import { SheerIdBanner } from 'Features/SheerIdPromoBanner/SheerIdBanner';
import { PlanSelection } from 'Features/Plans/PlanSelection/PlanSelection';
import { isFirstResponderChurned, isMilitaryChurned } from 'Utils/SheerIdHelpers';
import { isVeteransAdvPlan } from 'Utils/VeteransAdvHelpers';
import { useStore } from 'Hooks/useStore';
import './SignUpPlansContainer.css';

export const SignUpPlansContainer = () => {
  const location = useLocation();
  const { preSelectedPlan = '' } = useParams();

  const { hasSubscription, isStatusSuccess, isIAPUser, hasActiveSubscription } = useStore('subscription');

  const { enableSheerIdBanner } = useStore('appConfig.defaultConfig');
  const subscription = useStore('subscription');
  const { isAuthenticated } = useStore('user');
  const { allPlans, selectedPlan, isFetchingPlans, getPlansSuccess } = useStore('plans');
  const { routes } = useStore('appConfig');
  const { bango, sheerId } = useStore('integrations');
  const { verificationId } = sheerId;
  const isBango = bango.subscriptionId;
  const isVeteransAdv = allPlans.some((plan) => isVeteransAdvPlan(plan.planId));
  const isLoading = (isFetchingPlans && !getPlansSuccess) || !allPlans.length;
  const shouldRedirect = isAuthenticated && isStatusSuccess && hasSubscription && !isBango;

  useEffect(() => {
    if (!isLoading && !shouldRedirect) {
      trackEvent(TRACKING_ENUMS.EVENT_PLAN_SELECT_START);
    }
  }, [isLoading, shouldRedirect]);

  if (shouldRedirect) {
    if (verificationId) {
      if (isIAPUser && hasActiveSubscription) {
        return (
          <Navigate replace to={{ search: location.search, pathname: routes.signupCurrentSubscriberMilitaryFirst }} />
        );
      }
      const param = preSelectedPlan ? '/' + preSelectedPlan : '';
      return <Navigate replace to={{ search: location.search, pathname: routes.changePlans + param }} />;
    }
    return <Navigate replace to={{ search: location.search, pathname: routes.signupCurrentSubscriber }} />;
  }

  const isSheerIdChurned =
    isFirstResponderChurned(subscription.isChurnedUser, subscription.restartChurnedUserDetails) ||
    isMilitaryChurned(subscription.isChurnedUser, subscription.restartChurnedUserDetails);

  const showSheerIdBanner = enableSheerIdBanner && !isSheerIdChurned && !verificationId && !isVeteransAdv;

  return (
    <CenterFrameLayout
      title={isLoading ? 'Checking your subscription' : 'Choose a Plan'}
      showLoader={isLoading}
      modernLayout
      customClass="signUpPlansContainer"
    >
      {showSheerIdBanner && <SheerIdBanner />}
      <PlanSelection plans={allPlans} selectedPlan={selectedPlan} />
    </CenterFrameLayout>
  );
};
